import React from 'react'
import PropTypes from 'prop-types'
import Toggler from 'hoc/toggler'

// State-controlled dropdown (used primaryl by public pages form)
const SelectDropdown = ({
  input,
  options = [],
  isOpen,
  toggle,
  placeholder = 'Select',
  groupClassName,
  errorClassName,
  meta: { touched, error },
  inputClassName = ''
}) => {
  const selected = options.find(({ value }) => value === input.value.value) // input.value.value due to object being utilized at line 25

  const renderOptions = () => (
    <ul className="mt-2">
      {options.map((option, i) => (
        <li
          className={`text-sm font-normal hover:text-primary-orange py-1 ${inputClassName} ${input.value.value ===
            option.value && 'text-primary-orange'}`}
          key={i}
          onClick={() => {
            input.onChange(option)
            toggle()
          }}
        >
          {option.label}
        </li>
      ))}
    </ul>
  )

  return (
    <div className={groupClassName}>
      <div className={`w-full border rounded-lg p-3 cursor-pointer`}>
        <div className="flex w-full justify-between items-center" onClick={toggle}>
          <p className="text-sm">{selected ? selected.label : placeholder}</p>
          <i className={`fa ${isOpen ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
        </div>
        {isOpen && renderOptions()}
      </div>
      {touched && error && <p className={errorClassName}>{error}</p>}
    </div>
  )
}

SelectDropdown.propTypes = {
  options: PropTypes.array,
  input: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  groupClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
}

export default Toggler(SelectDropdown)
